import { MFButton } from "../../../../common/components/MFButton";
import MFModal from "../../../../common/containers/MFModal";

export function ModalDeleteFolder({ isOpen, onClose, deleteFolder, folderId }) {
  const handleDeleteFolder = () => {
    if (!folderId) return;
    deleteFolder(folderId);
    onClose();
  };

  return (
    <MFModal isOpen={isOpen} onClose={onClose}>
      <p className="modal-title">Voulez-vous vraiment supprimer ce dossier ?</p>
      <p className="modal-text" style={{ marginBottom: "20px" }}>
        En supprimant ce dossier, vous ne supprimerez pas les calculs qui ont pu y être ajoutés. 
        Ceux-ci seront toujours accessibles depuis la vue “Tous Mes Calculs”.
      </p>
      <div className="d-flex align-items-center justify-content-end mt-3">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={handleDeleteFolder}>
          Supprimer le dossier
        </MFButton>
      </div>
    </MFModal>
  );
}
